module.exports = __webpack_public_path__ + "img/next_point.90ad9ccb.svg";